import { connect } from 'react-redux';
import { actions } from "../../../../../redux/modules/reportes/despachos";
import DetalleDespacho from './DetalleDespacho';


const ms2p = (state) => {
    return {
        ...state.reporte_despachos,
    };
};

const md2p = {
    ...actions
};

export default connect(ms2p, md2p)(DetalleDespacho);
